import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.less";
import "./configs/i18n";
import reportWebVitals from "./reportWebVitals";
import StoreProvider from "./stores";
import "core-js/stable";
import "regenerator-runtime/runtime";
import Loading from "./components/Loading";
import Cookies from "js-cookie";

if (!localStorage.getItem("cookie_migrated_v1")) {
    ["access_token", "refresh_token", "user_id", "role"].forEach((name) => {
        Cookies.remove(name);                                  // host-only (old, no domain)
        Cookies.remove(name, { domain: "app.cloudbook.vn" }); // explicit old subdomain
    });
    localStorage.setItem("cookie_migrated_v1", "1");
}

const Views = lazy(() => import("./views"));

const rootElement = document.getElementById("root");

try {
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <StoreProvider>
                <Suspense fallback={<Loading />}>
                    <Views />
                </Suspense>
            </StoreProvider>
        );
    } else {
        console.error("Root element not found");
    }
} catch (error) {
    console.log(`Somethings wrong! ${error}`);
}

reportWebVitals();
